import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IsTrue.svg",
  "use": "IsTrue.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"IsTrue.svg\"><path clip-rule=\"evenodd\" d=\"m8.25 7c-2.89948 0-5.25 2.41766-5.25 5.4 0 2.9823 2.35052 5.4 5.25 5.4h7.5c2.8995 0 5.25-2.4177 5.25-5.4 0-2.98234-2.3505-5.4-5.25-5.4zm7.35 9c1.9882 0 3.6-1.6118 3.6-3.6s-1.6118-3.6-3.6-3.6-3.6 1.6118-3.6 3.6 1.6118 3.6 3.6 3.6z\" fill=\"#101820\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol